import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import './i18n/config';
import ErrorBoundary from './components/common/ErrorBoundary';

// Suppress harmless ResizeObserver loop errors (common with Material-UI)
const isResizeObserverError = (msg: string): boolean =>
  msg.includes('ResizeObserver loop');

window.addEventListener('error', (event) => {
  if (isResizeObserverError(event.message || '')) {
    event.stopImmediatePropagation();
  }
});

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
root.render(
  <React.StrictMode>
    <ErrorBoundary>
      <App />
    </ErrorBoundary>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
